import { Severity } from '../../../../common/enums/Severity';
import { InventoryRecap } from '../../../../common/inventory/models/InventoryRecap';
import { Preset } from '../../../../common/models/valueObjects/Preset';
import { Issue } from './valueObjects/Issue';

export class OrganizationPrintData {
  private issueGroups: Record<Severity, Issue[]>;

  constructor(
    private readonly name: string,
    private readonly projects: Preset[],
    private readonly tags: string[],
    private readonly profiles: Preset[],
    private readonly issues: Issue[] | null,
    private readonly inventory: InventoryRecap | null
  ) {
    this.issueGroups = {
      [Severity.HIGH]: [],
      [Severity.MED]: [],
      [Severity.LOW]: [],
      [Severity.PASSED]: [],
      [Severity.FILTERED]: [],
      [Severity.DISABLED]: [],
      [Severity.NA]: [],
      [Severity.NO_WARNING]: [],
    };
    for (const issue of this.issues ?? []) {
      this.issueGroups[issue.getSeverity()].push(issue);
    }
  }

  getName() {
    return this.name;
  }

  getProjects() {
    return this.projects;
  }

  getProfiles() {
    return this.profiles;
  }

  getTags() {
    return this.tags;
  }

  getInventory() {
    return this.inventory;
  }

  getIssueGroups() {
    return this.issueGroups;
  }

  hasPriorityIssues() {
    return [Severity.PASSED, Severity.LOW, Severity.MED, Severity.HIGH].some((s) => this.issueGroups[s].length > 0);
  }

  hasHiddenIssues() {
    return [Severity.DISABLED, Severity.FILTERED, Severity.NA, Severity.NO_WARNING].some((s) => this.issueGroups[s].length > 0);
  }
}
